<style lang="scss"></style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
    <div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 10px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t("buliangyuanyinzuiduo") }}
      </p>
    </div>
    <div v-if="cockpitData.badQuantityData.length === 0" style="display: flex;justify-content: center;align-items: center;margin-top: 140px">
      <span style="color: #909399;font-size: 16px">{{ $t('zanwushuju') }}</span>
    </div>
    <div style="display: flex;justify-content: space-between;padding: 10px 20px;" :style="{ height: chartHeight + 'px' }">
      <div id="monitorReasonSortChart" style="flex:1" :style="{ height: chartHeight - 20 + 'px' }"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_cockpit_reason_sort",
  components: {},
  props: {
    cockpitData: {
      type: Object,
      default: function () {
        return {
          badQuantityData: [],
        };
      },
    },
  },
  data() {
    return {
      chart: null,
      option: null,
      chartHeight: 0,
      reasons: {},
    };
  },
  computed: {},
  created() { },
  mounted() {
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
    this.makeChart();
    this.resize();
  },
  watch: {
    cockpitData(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.makeChart();
    },
  },
  destroyed() { },
  methods: {
    makeChart() {
      if (this.cockpitData.badQuantityData == null) {
        return
      }
      let all = 0;
      for (var i = 0; i < this.cockpitData.badQuantityData.length; i++) {
        all += this.cockpitData.badQuantityData[i].badQuantity;
      }

      this.reasons.descs = this.cockpitData.badQuantityData.map((item) => {
        return item.desc;
      });
      this.reasons.badQuantities = this.cockpitData.badQuantityData.map((item) => {
        return item.badQuantity;
      });
      this.reasons.rates = this.cockpitData.badQuantityData.map((item) => {
        return (item.badQuantity / all) * 100;
      });

      let newRates = [];
      for (var i = 0; i < this.reasons.rates.length; i++) {
        let newRate = 0;
        for (var j = 0; j <= i; j++) {
          newRate += this.reasons.rates[j];
        }
        newRates[i] = newRate;
      }
      this.reasons.rates = newRates;

      // this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
      if (!this.chart) {
        setTimeout(() => {
          this.initChart();
        }, 100);
      }

      console.log(this.reasons);

      setTimeout(() => {
        this.option.xAxis[0].data = this.reasons.descs;
        this.option.series[0].data = this.reasons.badQuantities;
        this.option.series[1].data = this.reasons.rates;

        this.chart.setOption(this.option);
      }, 200);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20;
        if (!this.chart) {
          return;
        }

        this.chart.getDom().style.height = this.chartHeight - 20 + "px";
        this.chart.resize();
      }, 800);
    },
    initChart() {
      this.option = {
        backgroundColor: null,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              formatter: "{value} ",
            },
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          backgroundColor: "rgba(0,0,0,0.8)",
          borderWidth: 0,
          textStyle: {
            color: "#C0C4CC",
          },
          valueFormatter: (value) => {
            return value;
          },
        },

        grid: {
          left: "0",
          right: "10",
          bottom: "0",
          top: "50",
          containLabel: true,
        },
        legend: {
          left: "center",
          top: "0%",
          textStyle: {
            color: "#FFFFFF",
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },

        xAxis: [
          {
            show: true,
            type: "category",
            name: "",
            nameLocation: "end",
            nameTextStyle: {
              fontSize: 12,
            },
            inverse: false,
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "#000",
                width: 1,
              },
            },
            axisTick: {
              show: false,
              alignWithLabel: false,
              interval: "auto",
              inside: false,
              length: 5,
              lineStyle: {
                type: "solid",
                width: 1,
                color: "#909399",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                width: 1,
                color: "#909399",
              },
            },
            axisLabel: {
              margin: 8,
              interval: 0,
              rotate: 0,
              fontSize: 12,
              color: "#C0C4CC",
              formatter: (desc) => {
                return desc.substring(0, 4) + (desc.length > 4 ? "..." : "");
              },
            },
            data: [],
          },
        ],
        yAxis: [
          {
            show: true,
            type: "value",
            name: "",
            min: 0,
            nameTextStyle: {
              color: "#909399",
            },

            axisLine: {
              show: false,
              lineStyle: {
                color: "#909399",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value} ",
              rotate: 0,
              textStyle: {
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
          {
            show: true,
            type: "value",
            name: "",
            min: 0,
            max: 100,
            nameTextStyle: {
              color: "#909399",
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#909399",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: this.cockpitData.badQuantityData.length === 0 ? '' : "{value} %",
              rotate: 0,
              textStyle: {
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
        ],
        series: [
          {
            name: this.cockpitData.badQuantityData.length === 0 ? '' : this.$t("buliangshuliang"),
            type: "bar",
            barWidth: "12px",
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#FDC341",
                  },
                  {
                    offset: 1,
                    color: "#FF4941",
                  },
                ]),
                barBorderRadius: 6,
              },
            },
            label: {
              show: false,
              rotate: 0,
              color: "#419FFF",
              position: "top",
              fontSize: 12,
            },
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            data: [],
          },
          {
            name: this.cockpitData.badQuantityData.length === 0 ? '' : this.$t("buliangbaifenbi"),
            type: "line",
            yAxisIndex: 1, //这个很重要，这个是对应哪个轴显示的
            label: {
              normal: {
                show: true,
                position: "top",
                formatter: (params) => {
                  return this.reasons.rates[params.dataIndex].toFixed(1) + " %";
                },
                color: "#FFFFFF",
              },
            },
            //symbol: 'none',
            itemStyle: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#FF3A5E",
                },
                {
                  offset: 1,
                  color: "#FF3A5E",
                },
              ]),
              barBorderRadius: 6,
            },
            tooltip: {
              valueFormatter: function (value) {
                return value.toFixed(1) + " %";
              },
            },
            data: [],
          },
        ],
      };

      var chartDom = document.getElementById("monitorReasonSortChart");
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
    },
  },
};
</script>
